import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@thilke/ui/components/ui/dropdown-menu";
import { deleteNode } from "../state/graph-actions";
import { useUIStore } from "../state/ui-store";
import { useYDoc } from "../state/yjs-provider";

export function ContextOverlay() {
  const activeMenu = useUIStore((s) => s.activeContextMenu);
  const setContextMenu = useUIStore((s) => s.setContextMenu);
  const setRightTab = useUIStore((s) => s.setRightTab);
  const doc = useYDoc();

  const handleClose = () => setContextMenu(null);

  const handleDelete = () => {
    if (!activeMenu) return;
    deleteNode(doc, activeMenu.entityId);
    handleClose();
  };

  const handleInspect = () => {
    setRightTab("inspector");
    handleClose();
  };

  return (
    <div
      style={{
        position: "absolute",
        left: activeMenu?.x ?? 0,
        top: activeMenu?.y ?? 0,
        width: 1,
        height: 1,
        pointerEvents: "none",
        zIndex: 100,
      }}
    >
      <DropdownMenu
        open={!!activeMenu}
        onOpenChange={(open) => !open && handleClose()}
      >
        <DropdownMenuTrigger asChild>
          <div />
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          sideOffset={5}
          onCloseAutoFocus={(e) => e.preventDefault()}
          className="min-w-40 border-white/10 bg-background/95 backdrop-blur-md shadow-2xl"
        >
          <div className="px-2 py-1.5 text-xs font-semibold text-muted-foreground break-all">
            {activeMenu?.entityId.substring(0, 8)}...
          </div>
          <DropdownMenuSeparator className="bg-white/10" />
          <DropdownMenuItem onClick={handleInspect} className="cursor-pointer">
            Inspect Properties
          </DropdownMenuItem>
          <DropdownMenuItem className="cursor-pointer">
            Link to Journal
          </DropdownMenuItem>
          <DropdownMenuSeparator className="bg-white/10" />
          <DropdownMenuItem
            onClick={handleDelete}
            className="cursor-pointer text-red-400 focus:text-red-400 focus:bg-red-400/10"
          >
            Delete Entity
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
